/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum PatientDisplacementPersonInformationAliases {
  AVATAR_ENTRADA = 'avatar-entrada',
  AVATAR_SAIDA = 'avatar-saida',
  BARCODE_ARRIVALS = 'barcode-arrivals',
  BARCODE_PRESCR = 'barcode-prescr',
  CARD_CONTAINER_BODY_HISTORICO = 'card-container-body-historico',
  CARD_CONTAINER_BODY_SAIDAS = 'card-container-body-saidas',
  CARD_CONTAINER_HISTORICO = 'card-container-historico',
  CARD_CONTAINER_SAIDAS = 'card-container-saidas',
  CARD_CONTAINER_ZONE_HIST_IN = 'card-container-zone-hist-in',
  CARD_CONTAINER_ZONE_HIST_OUT = 'card-container-zone-hist-out',
  CARD_CONTAINER_ZONE_SAIDAS = 'card-container-zone-saidas',
  CARD_CONTAINER_ZONE_TITLE = 'card-container-zone-title',
  CONTEXTUAL_BAR_CHEGADAS = 'contextual-bar-chegadas',
  CONTEXTUAL_BAR_SAIDAS = 'contextual-bar-saidas',
  CONTEXTUAL_BAR_TROCA = 'contextual-bar-troca',
  DECK_SAIDAS = 'deck-saidas',
  DECK_TROCA_LOCAL = 'deck-troca-local',
  FETCH_SAIDAS = 'fetch-saidas',
  FETCH_TROCA_LOCAL = 'fetch-troca-local',
  FIELD_ENTRADA = 'field-entrada',
  FIELD_INFO = 'field-info',
  FIELD_SAIDA = 'field-saida',
  FIELD_SETOR = 'field-setor',
  FIELD_TITLE = 'field-title',
  FRAGMENT_REFERENCE_INFO_BAR = 'fragment-reference-info-bar',
  GLOBAL_ACTIONS_BUTTONS = 'global-actions-buttons',
  GLOBAL_ACTIONS_TROCA_LOCAL = 'global-actions-troca-local',
  LAYOUT_INFO = 'layout-info',
  LAYOUT_PERSON_INFORMATION = 'layout-person-information',
  LAYOUT_SAIDAS = 'layout-saidas',
  LAYOUT_TROCA_LOCAL = 'layout-troca-local',
  MAPPER_SAIDAS = 'mapper-saidas',
  MAPPER_TROCA_LOCAL = 'mapper-troca-local',
  PANEL_0 = 'panel-0',
  PANEL_CHEGADAS = 'panel-chegadas',
  PANEL_DECK_SAIDAS = 'panel-deck-saidas',
  PANEL_INFO = 'panel-info',
  PANEL_SAIDAS = 'panel-saidas',
  PANEL_TAB_CONTROL = 'panel-tab-control',
  PANEL_TROCA_LOCAL = 'panel-troca-local',
  PATIENT_DISPLACEMENT_PERSONAL_INFORMATION_TAB_CONTROL = 'patient-displacement-personal-information-tab-control',
  SUPPRESS_HEADING_MARGIN_TABS = 'suppress-heading-margin-tabs',
  TAB_CHEGADAS = 'tab-chegadas',
  TAB_INFO = 'tab-info',
  TAB_SAIDAS = 'tab-saidas',
  TAB_TROCA_LOCAL_PA = 'tab-troca-local-pa',
  TEXT_ENTRADA = 'text-entrada',
  TEXT_INFO = 'text-info',
  TEXT_SAIDA = 'text-saida',
  TEXT_SETOR = 'text-setor',
  TEXT_TITLE = 'text-title',
  TROCAR_LOCAL_BUTTON = 'trocar-local-button',
}
export { PatientDisplacementPersonInformationAliases };
